export const data = function() {
  return {
    isDebug: true,
    loading: false,
    tabs: [],
    styles: {
      mainContainer: {
        minHeight: '1000px'
      }
    },
    transitionName: 'slide-down'
  }
}
